import { trigger, transition, style, animate } from '@angular/animations';

export const headerAnimations = [
  trigger('slideInOut', [
    transition(':enter', [
      style({
        height: '0px',
        opacity: 0,
        transform: 'translateY(-10px)',
        overflow: 'hidden'
      }),
      animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({
        height: '*',
        opacity: 1,
        transform: 'translateY(0px)'
      }))
    ]),
    transition(':leave', [
      style({
        height: '*',
        opacity: 1,
        transform: 'translateY(0px)',
        overflow: 'hidden'
      }),
      animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', style({
        height: '0px',
        opacity: 0,
        transform: 'translateY(-10px)'
      }))
    ])
  ])
];
